import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/modal-exit/arrow_back_ios_new.svg")